import {
  NEWS_AND_PRESS_RELEASE_PAGE_TYPES,
  READ_THE_ARTICLE_LABEL,
  READ_THE_PRESS_RELEASES_LABEL,
} from "@/constants";

import Styles from "./index.module.scss";

const ArticleVideos = ({ data = {} }) => {
  return data?.map(item => {
    const { pageTitle_s, canonicalUrl_s, id, pageType_s } = item;
    const isValidHref =
      canonicalUrl_s &&
      typeof canonicalUrl_s === "string" &&
      canonicalUrl_s?.trim().length > 0;

    let hrefPath = "";
    if (isValidHref) {
      if (canonicalUrl_s?.startsWith("https://")) {
        const pathSegments = canonicalUrl_s
          ?.split("https://")[1]
          ?.split("/")
          ?.slice(1)
          ?.join("/");
        hrefPath = pathSegments ? `/${pathSegments}` : canonicalUrl_s;
      }
    }

    const readLinkLabel = NEWS_AND_PRESS_RELEASE_PAGE_TYPES?.includes(
      pageType_s
    )
      ? READ_THE_PRESS_RELEASES_LABEL
      : READ_THE_ARTICLE_LABEL;

    return (
      <div
        className={Styles.productArticles}
        key={id || canonicalUrl_s || pageTitle_s}
      >
        <div className="article-content">
          {pageTitle_s && (
            <span className="article-title">
              {pageTitle_s?.replace(/&amp;/g, "and")}{" "}
            </span>
          )}
          <span className="article-date"></span>
          {isValidHref ? (
            <a
              href={hrefPath}
              className="article-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {readLinkLabel}
            </a>
          ) : (
            <button
              type="button"
              className="article-link"
              style={{
                background: "none",
                border: "none",
                padding: 0,
                color: "inherit",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {readLinkLabel}
            </button>
          )}
        </div>
      </div>
    );
  });
};

export default ArticleVideos;
